@if (shape === ButtonShape.ROUNDED) {
  <button
    mat-icon-button
    class="round-button flex items-center justify-center justify-self-center"
    [attr.aria-label]="ariaLabel"
    [color]="color"
    [ngClass]="buttonClasses + ' ' + style"
    [disabled]="disabled"
    [type]="type">
    <ng-container *ngTemplateOutlet="buttonIcon" />
  </button>
} @else {
  @switch (style) {
    @case (ButtonStyle.OUTLINE) {
      <button
        mat-stroked-button
        class="outlined-button"
        [attr.matIconPrefix]="iconPosition === 'prefix'"
        [attr.matIconSuffix]="iconPosition === 'suffix'"
        [ngClass]="buttonClasses"
        [disabled]="disabled"
        [attr.aria-label]="ariaLabel"
        [type]="type">
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
      </button>
    }
    @case (ButtonStyle.BASIC) {
      <button
        mat-button
        class="basic-button"
        [attr.matIconPrefix]="iconPosition === 'prefix'"
        [attr.matIconSuffix]="iconPosition === 'suffix'"
        [ngClass]="buttonClasses"
        [disabled]="disabled"
        [attr.aria-label]="ariaLabel"
        [type]="type">
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
      </button>
    }
    @default {
      <button
        mat-flat-button
        class="filled-button"
        [attr.matIconPrefix]="iconPosition === 'prefix'"
        [attr.matIconSuffix]="iconPosition === 'suffix'"
        [ngClass]="buttonClasses"
        [disabled]="disabled"
        [type]="type"
        [attr.aria-label]="ariaLabel"
        [color]="color">
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
      </button>
    }
  }
}

<ng-template #buttonContent>
  <div class="flex items-center justify-center">
    <mat-spinner *ngIf="loading" class="flex" diameter="16" />
    <div *ngIf="icon && iconPosition === 'prefix'" class="flex">
      <ng-container *ngTemplateOutlet="buttonIcon" />
    </div>
    <div
      #contentRef
      class="{{ contentRef.innerHTML.trim() && icon && iconPosition === 'prefix' ? 'ml-2' : '' }} {{
        contentRef.innerHTML.trim() && icon && iconPosition === 'suffix' ? 'mr-2' : ''
      }}">
      <ng-content></ng-content>
    </div>
    <div *ngIf="icon && iconPosition === 'suffix'" class="flex">
      <ng-container *ngTemplateOutlet="buttonIcon" />
    </div>
  </div>
</ng-template>

<ng-template #buttonIcon>
  <mat-icon *ngIf="icon" class="material-icons-outlined" [attr.aria-label]="ariaLabel + icon" [appIconName]="icon" />
</ng-template>
